var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSortBy = function SvgSortBy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.195 4.707v14.586M5.333 9.529l4.862-4.862m4.052.08v14.586l4.862-4.862",
    stroke: "#EFEEEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export { SvgSortBy as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjE5NTMgNC43MDcxN1YxOS4yOTI4TTUuMzMzMzcgOS41Mjg1NEwxMC4xOTUzIDQuNjY2NjZNMTQuMjQ2OCA0Ljc0NzY5VjE5LjMzMzNMMTkuMTA4NyAxNC40NzE0IiBzdHJva2U9IiNFRkVFRUUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";